export default function UnlockButton({ className = "", onClick, price }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-xl font-semibold shadow-md transition duration-200 ease-in-out
        bg-rainbow-pastel
        ${className}`}
    >
      🔓 Unlock Full Digital Deck{price ? ` — ${price}` : ""}
    </button>
  );
}
